import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-detailed-report",
  templateUrl: "./detailed-report.component.html",
  styleUrls: ["./detailed-report.component.scss"],
})
export class DetailedReportComponent implements OnInit {
    private destroy$: Subject<void> = new Subject<void>();
      private cancelPreviousRequests$ = new Subject<void>();
  settings = {};
  productionOperation: any;
  timezone: any;
  oeeAnalysis: any;
  custId;
  maxdate: any;
  mindate: any;
  action: any;
  toDate;
  fromDate: any;
  currentPage = 1;
  currendowntimetPage = 1;
  currenrejectiontPage = 1;
  itemsPerPage = 5;
  pageSize;
  downtimeitemsPerPage = 5;
  downtimepageSize;
  rejectionitemsPerPage = 5;
  rejectionpageSize;
  tableData: any = {};
  userDetails: any;
  selectedDepartment: any;
  selectedDepartmentId: any;
  exportViaMail: boolean = false;
  departmentData: any = [];
  showTable: boolean = false;
  breadCrumbItems: Array<{}>;
  pdfBool: boolean = false;
  csvBool: boolean = false;
  mailform: FormGroup;
  base64String;
  custName: any;
  selectedMachines: any = [];
  dropdownList: any;
  selectedType = "Downtime";
  hourlyOEE: any;
  selectedPameterType = "OEE";
  analysisdata: any;
  selectedDepartmentShift: any = [];
  selectedShift: any;
  currentShiftData: any;
  shiftData: any = [];
  selectedShiftId: any;
  tableDatas: any;
  downtimeReasonData: any[] = [];
  filteredData: any[] = [];
  rejectionReasonData: any[] = [];
  rejectionfilteredData: any[] = [];

  filters = {
    machineName: "",
    shiftName: "",
    status: "",
    reason: "",

    subreason: "",

  };
  rejectionfilters = {
    machineName: "",
    shiftName: "",
    reason: ""

  };

  machineOptions: string[] = [];
  shiftOptions: string[] = [];
  statusOptions: string[] = [];
  reasonOptions: string[] = [];

  subreasonOptions: string[] = [];

  machinerejectionOptions: string[] = [];
  shiftrejectionOptions: string[] = [];
  reasonrejectionOptions: string[] = [];
  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private currShift: GetCurrentShift
  ) {
    this.userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custName = this.userDetails["user"]["name"];
    this.custId = this.userDetails["user"]["custId"];
    this.timezone = this.userDetails["user"]["timeZone"];
  }
  ngOnInit(): void {
    this.settings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.breadCrumbItems = [
      { label: "K2" },
      { label: "Day Report", active: true },
    ];
    this.getDepartment();
    this.mailform = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.convertImageToBase64();
    this.auditLogs()
  }
  auditLogs() {
    let obj = {
      custID: this.custId
    }
    this.dataservice
      .reportApi(
        "auditlog/dayreport",
        obj
      ).subscribe(
        (res) => {

        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );

  }

  onMachineSelect(event?: any) {
    if (event) {
      this.selectedMachines = event;
    }
    if (this.tableData["downtimedata"].length) {
      this.updateChart(this.tableData["downtimedata"]);
    }
  }
  updateChart(data: any) {
    if (this.selectedMachines.length === 0 || !data) {
      this.oeeAnalysis = {
        title: {
          text: "No Data",
          left: "center",
          top: "middle",
          textStyle: {
            fontSize: 18,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const selectedIds = this.selectedMachines.map((m) => m.item_id);
    const filtered = data.filter((d) => selectedIds.includes(d.machineId));
    if (this.selectedType != "Downtime") {
      this.oeeAnalysis = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            color: "#333",
          },
        },
        xAxis: {
          type: "category",
          data: filtered.map((item) => item.Machine),
        },
        yAxis: { type: "value" },
        series: [
          {
            name: this.selectedType,
            type: "bar",
            itemStyle: {
              color: "#719FB0",
            },
            data: filtered.map((item) => item[this.selectedType]),
            label: {
              show: true,
              position: "top",
              fontWeight: "bold",
            },
          },
        ],
      };
    } else {
      // 1. Get all unique reasons
      const reasonsSet = new Set();
      filtered.forEach((machine) => {
        machine?.downtimeReasons?.forEach((part) =>
          reasonsSet.add(part.reason)
        );
      });
      const reasons = Array.from(reasonsSet);
      // 2. Build dataset header
      const header = ["Machine", ...reasons];
      // 3. Build dataset source rows
      const source = [header];
      filtered.forEach((machine) => {
        let row: string[] = [];
        row = [machine["Machine"]];
        reasons.forEach((reason) => {
          const part = machine.downtimeReasons.find((p) => p.reason === reason);
          row.push(part ? part["duration"].toString() : "0");
        });
        source.push(row);
      });
      // 4. Build dynamic series
      const series = reasons.map((reason) => ({
        type: "bar",
        stack: "total",
        name: reason,
        encode: { x: "Machine", y: reason },
      }));

      this.oeeAnalysis = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            color: "#333",
          },
          formatter: function (params) {
            let tooltipText = params[0].axisValue + "<br/>";
            params.forEach((item) => {
              const totalMinutes = item.data[item.encode.y[0]];
              if (totalMinutes > 0) {
                const totalSeconds = totalMinutes * 60;
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
                const formatted = [
                  hours.toString().padStart(2, "0"),
                  minutes.toString().padStart(2, "0"),
                  seconds.toString().padStart(2, "0"),
                ].join(":");

                tooltipText += `${item.marker} ${item.seriesName}: ${formatted}<br/>`;
              }
            });
            return tooltipText;
          },
        },
        xAxis: {
          type: "category",
          name: "Machines",
          nameLocation: "middle",
          nameGap: 30,
        },
        yAxis: {
          type: "value",
          name: "Downtime (minutes)",
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 50,
        },
        dataset: {
          source: source,
        },
        series: series,
      };
    }
  }
  convertImageToBase64() {
    const imagePath = "assets/wimera/Wimera_Logo_wSlogan_Green.png";
    this.http.get(imagePath, { responseType: "blob" }).subscribe(
      (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      (error) => {
        console.error("Error loading the image:", error);
      }
    );
  }
  getDepartment() {
    this.departmentData = [];
    this.dataservice
      .get(`department?custId=${this.custId}`)
      .subscribe((res: any) => {
        if (res) {
          this.shiftData = [];
          this.departmentData = res["data"];
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.selectedDepartmentId = this.departmentData[0]["departmentId"];
          this.selectedDepartmentShift = this.departmentData[0]["shiftData"];
          this.shiftData = [
            { shiftName: "All Shift" },
            ...this.selectedDepartmentShift,
          ];
          this.selectedShift = "All Shift";
          this.selectedShiftId = "All Shift";
          this.currentShiftData = this.currShift.getCurrentShift(
            this.selectedDepartmentShift,
            this.timezone
          );
          if (this.currentShiftData && this.currentShiftData.currentDate) {
            const today = moment(this.currentShiftData.currentDate)
              .subtract(1, "days")
              .format("YYYY-MM-DD");
            this.maxdate = today;
            this.fromDate = today;
            this.getData();
          }
        }
      });
  }
  select_Department(data: any) {
    this.selectedDepartment = data;
    this.shiftData = [];
    const filter = this.departmentData.filter(
      (val) => val.departmentName === data
    );
    this.selectedDepartmentId = filter[0]["departmentId"];
    this.selectedDepartmentShift = filter[0]["shiftData"];
    this.shiftData = [
      { shiftName: "All Shift" },
      ...this.selectedDepartmentShift,
    ];
    this.selectedShift = "All Shift";
    this.selectedShiftId = "All Shift";
    this.currentShiftData = this.currShift.getCurrentShift(
      this.selectedDepartmentShift,
      this.timezone
    );
    if (this.currentShiftData && this.currentShiftData.currentDate) {
      const today = moment(this.currentShiftData.currentDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.maxdate = today;
      this.fromDate = today;
      // this.getData();
    }
  }
  select_Shift(data: any) {
    this.selectedShift = data;
    if (this.selectedShift != "All Shift") {
      const filtershift = this.selectedDepartmentShift?.filter(
        (val) => val.shiftName === this.selectedShift
      );
      this.selectedShiftId = filtershift[0]["usershiftId"];
    } else {
      this.selectedShiftId = "All Shift";
    }
    // this.getData();
  }
  select_Date(e: any) {
    this.fromDate = e;
    // this.getData();
  }
  hasBreakdown: boolean;
  hasInterlock: boolean;
  hasmchBreakdown: boolean;
  hasmchInterlock: boolean;
  hasmchpin2: boolean;
  getData() {
    this.cancelPreviousRequests$.next();
    
    let param = {
      custId: this.custId,
      date: this.fromDate,
      // toDate: this.fromDate,
      usershiftId: this.selectedShiftId,
      department: this.selectedDepartment,
      departmentId: this.selectedDepartmentId,
    };
      // ── Clear previous data ──
  this.tableData = {};
  this.showTable = false;
  this.downtimeReasonData = [];
  this.filteredData = [];
  this.rejectionReasonData = [];
  this.rejectionfilteredData = [];
  this.dropdownList = [];
  this.selectedMachines = [];
    this.getHourlyOee(null);
  this.getProductionChart(null);
  this.updateChart(null);

     this.toastr.info("Please wait while processing", "", { disableTimeOut: true });
    this.dataservice
      .reportApi(
        "reports/dailyProduction",
        param
      ).pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.toastr.clear();
            this.showTable = true;
            this.tableData = res["tabledata"];
            this.hasBreakdown = this.tableData?.summary?.BreakdownTime !== undefined;
            this.hasInterlock = this.tableData?.summary?.InterlockTime !== undefined;
            this.hasmchBreakdown = this.tableData?.machines.some(
              m => 'BreakdownTime' in m
            );
            this.hasmchpin2 = this.tableData?.machines.some(
              m => 'Pin2Count' in m
            );

            this.hasmchInterlock = this.tableData?.machines.some(
              m => 'InterlockTime' in m
            );

            (this.dropdownList = this.tableData["downtimedata"].map(
              (item) => ({
                item_id: item.machineId,
                item_text: item.Machine,
              })
            ));

            this.selectedMachines = [...this.dropdownList]; // All selected by default
            this.getHourlyOee(this.tableData);
            this.getProductionChart(this.tableData["summary"]);
            if (this.tableData["downtimedata"].length) {
              this.updateChart(this.tableData["downtimedata"]);
            }
            if (this.tableData["downtimeReasonData"].length) {
              this.downtimeReasonData = this.tableData["downtimeReasonData"];
              this.filteredData = [...this.downtimeReasonData];

              // Build distinct dropdown options
              this.machineOptions = [
                ...new Set(this.downtimeReasonData.map((d) => d.machineName)),
              ];
              this.shiftOptions = [
                ...new Set(this.downtimeReasonData.map((d) => d.shiftName)),
              ];
              this.statusOptions = [
                ...new Set(this.downtimeReasonData.map((d) => d.status)),
              ];
              this.reasonOptions = [
                ...new Set(this.downtimeReasonData.map((d) => d.reason)),
              ];
              this.subreasonOptions = [
                ...new Set(this.downtimeReasonData.map((d) => d.subreason)),
              ];
            } else {
              this.downtimeReasonData = []
              this.filteredData = []
            }
            if (this.tableData["rejectionReasonData"].length) {
              this.rejectionReasonData = this.tableData["rejectionReasonData"];
              this.rejectionfilteredData = [...this.rejectionReasonData];

              // Build distinct dropdown options
              this.machinerejectionOptions = [
                ...new Set(this.rejectionReasonData.map((d) => d.machineName)),
              ];
              this.shiftrejectionOptions = [
                ...new Set(this.rejectionReasonData.map((d) => d.shiftName)),
              ];
              this.reasonrejectionOptions = [
                ...new Set(this.rejectionReasonData.map((d) => d.reason)),
              ];
            } else {
              this.rejectionReasonData = []
              this.rejectionfilteredData = []
            }
          } else {
            this.toastr.clear();
            this.toastr.error("no record");
            this.showTable = false;
          }
        },
        (err) => {
          this.toastr.clear();
          this.getHourlyOee(null);
          this.getProductionChart(null);
          this.updateChart(null);
          this.toastr.error("no record");
          this.showTable = false;
        }
      );
  }

  getTimeOrNA(machine: any, key: string): string {
    if (!machine || !Object.prototype.hasOwnProperty.call(machine, key)) {
      return 'NA';
    }

    const value = machine[key];
    return this.formatMinutesToHHMMSS(value || 0);
  }

  applyFilters() {
    this.filteredData = this.downtimeReasonData.filter((item) => {
      return (
        (!this.filters.machineName || item.machineName === this.filters.machineName) &&
        (!this.filters.shiftName || item.shiftName === this.filters.shiftName) &&
        (!this.filters.status || item.status === this.filters.status) &&
        (!this.filters.reason || item.reason === this.filters.reason) &&
        (!this.filters.subreason || item.subreason === this.filters.subreason)
      );
    });
  }
  applyrejectionFilters() {
    this.rejectionfilteredData = this.rejectionReasonData.filter((item) => {
      return (
        (!this.rejectionfilters.machineName || item.machineName === this.rejectionfilters.machineName) &&
        (!this.rejectionfilters.shiftName || item.shiftName === this.rejectionfilters.shiftName) &&
        (!this.rejectionfilters.reason || item.reason === this.rejectionfilters.reason)
      );
    });
  }
  getHourlyOee(data: any) {
    if (this.selectedPameterType == "OEE") {
      if (
        !data ||
        data["hourlyData"].length === 0 ||
        !Array.isArray(data["hourlyData"]["Labels"]) ||
        !Array.isArray(data["hourlyData"]["Oee"]) ||
        !Array.isArray(data["hourlyData"]["Availability"]) ||
        !Array.isArray(data["hourlyData"]["Performance"]) ||
        !Array.isArray(data["hourlyData"]["Quality"]) ||
        data["hourlyData"]["Labels"].length === 0 ||
        data["hourlyData"]["Oee"].length !==
        data["hourlyData"]["Labels"].length ||
        data["hourlyData"]["Availability"].length !==
        data["hourlyData"]["Labels"].length ||
        data["hourlyData"]["Performance"].length !==
        data["hourlyData"]["Labels"].length ||
        data["hourlyData"]["Quality"].length !==
        data["hourlyData"]["Labels"].length
      ) {
        this.hourlyOEE = {
          title: {
            text: "No Data Available",
            left: "center",
            top: "middle",
            textStyle: {
              color: "#999",
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          xAxis: { show: false },
          yAxis: { show: false },
          series: [],
        };
        return;
      }

      this.hourlyOEE = {
        legend: {
          top: -5,
          textStyle: {
            fontSize: 10,
          },
          itemWidth: 10,
          itemHeight: 10,
          data: ["OEE", "Availability", "Performance", "Quality"],
        },
        grid: {
          top: "25%",
          left: "1%",
          right: "1%",
          bottom: "10%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: 0,
            start: 0,
            end: 100,
          },
        ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: { color: "#333", fontSize: 12 },
          formatter: (params) => {
            let unit = " %";
            let tooltipText = params[0].axisValue + "<br/>";
            params.forEach((item) => {
              tooltipText += `
      <span style="display:inline-block;margin-right:5px;
        border-radius:10px;width:9px;height:9px;
        background-color:${item.color};"></span>
      ${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return tooltipText;
          },
        },
        xAxis: {
          name: "Hours",
          nameLocation: "middle",
          nameGap: 20,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "category",
          data: data["hourlyData"]["Labels"],
          axisLabel: {
            rotate: 0,
            fontSize: 9,

            formatter: function (value) {
              return value.split(" - ")[1];
            },
          },
        },
        yAxis: {
          name: "Value (%)",
          nameLocation: "middle",
          nameGap: 25,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "value",
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "OEE",
            type: "line",
            data: data["hourlyData"]["Oee"],
            smooth: false,
            lineStyle: {
              width: 2,
            },
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#9C27B0",
            },
            label: {
              show: true,
              position: "top",
              color: "#000",
              fontWeight: "bold",
              formatter: function (params) {
                return params.value === 0 ? "" : `${params.value}%`;
              },
            },
          },
          {
            name: "Availability",
            type: "bar",
            data: data["hourlyData"]["Availability"],
            barGap: 0,
            itemStyle: {
              color: "#4CAF50",
            },
          },
          {
            name: "Performance",
            type: "bar",
            data: data["hourlyData"]["Performance"],
            barGap: 0,
            itemStyle: {
              color: "#FF9800",
            },
          },
          {
            name: "Quality",
            type: "bar",
            data: data["hourlyData"]["Quality"],
            barGap: 0,
            itemStyle: {
              color: "#2196F3",
            },
          },
        ],
      };
    } else if (this.selectedPameterType == "Energy") {
      if (
        !data ||
        data["hourlyData"].length === 0 ||
        !Array.isArray(data["hourlyData"]["Labels"]) ||
        !Array.isArray(data["hourlyData"]["Energy"]) ||
        data["hourlyData"]["Labels"].length === 0 ||
        data["hourlyData"]["Energy"].length !==
        data["hourlyData"]["Labels"].length
      ) {
        this.hourlyOEE = {
          title: {
            text: "No Data Available",
            left: "center",
            top: "middle",
            textStyle: {
              color: "#999",
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          xAxis: { show: false },
          yAxis: { show: false },
          series: [],
        };
        return;
      }
      this.hourlyOEE = {
        legend: {
          top: -5,
          data: ["Energy"],
        },
        grid: {
          top: "15%",
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: 0,
            start: 0,
            end: 100,
          },
        ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            color: "#333",
            fontSize: 12,
          },
          formatter: function (params) {
            const item = params[0];
            return `${item.axisValue}<br/>${item.seriesName}: ${item.data} kWh`;
          },
        },

        xAxis: {
          name: "Hours",
          nameLocation: "middle",
          nameGap: 20,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "category",
          data: data["hourlyData"]["Labels"],
          axisLabel: {
            rotate: 0,
            fontSize: 9,

            formatter: function (value) {
              return value.split(" - ")[1];
            },
          },
        },
        yAxis: {
          name: "Energy(kWh)",
          nameLocation: "middle",
          nameGap: 40,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "value",
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "Energy",
            type: "line",
            data: data["hourlyData"]["Energy"],
            smooth: false,
            label: {
              show: true,
              position: "top",
              color: "#000",
              fontWeight: "bold",
              formatter: function (params) {
                return params.value === 0 ? "" : `${params.value}`;
              },
            },
          },
        ],
      };
    } else if (this.selectedPameterType == "Production") {
      if (
        !data ||
        data["hourlyData"].length === 0 ||
        !Array.isArray(data["hourlyData"]["Labels"]) ||
        !Array.isArray(data["hourlyData"]["Partplanned"]) ||
        !Array.isArray(data["hourlyData"]["PartProduced"]) ||
        !Array.isArray(data["hourlyData"]["PartRejected"]) ||
        data["hourlyData"]["Labels"].length === 0 ||
        data["hourlyData"]["Partplanned"].length !==
        data["hourlyData"]["Labels"].length ||
        data["hourlyData"]["PartProduced"].length !==
        data["hourlyData"]["Labels"].length ||
        data["hourlyData"]["PartRejected"].length !==
        data["hourlyData"]["Labels"].length
      ) {
        this.hourlyOEE = {
          title: {
            text: "No Data Available",
            left: "center",
            top: "middle",
            textStyle: {
              color: "#999",
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          xAxis: { show: false },
          yAxis: { show: false },
          series: [],
        };
        return;
      }
      this.hourlyOEE = {
        legend: {
          textStyle: {
            fontSize: 10,
          },
          itemWidth: 10,
          itemHeight: 10,
          data: ["Planned", "Produced", "Rejected"],
        },
        grid: {
          top: "15%",
          left: "5%",
          right: "1%",
          bottom: "10%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: 0,
            start: 0,
            end: 100,
          },
        ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: { color: "#333", fontSize: 12 },
        },
        xAxis: {
          name: "Hours",
          nameLocation: "middle",
          nameGap: 20,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "category",
          data: data["hourlyData"]["Labels"],
          axisLabel: {
            rotate: 0,
            fontSize: 9,

            formatter: function (value) {
              return value.split(" - ")[1];
            },
          },
        },
        yAxis: {
          name: "Value",
          nameLocation: "middle",
          nameGap: 50,
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 10,
          },
          type: "value",
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "Planned",
            type: "line",
            data: data["hourlyData"]["Partplanned"],
            smooth: true,
            lineStyle: {
              width: 2,
            },
            symbol: "circle",
            symbolSize: 6,
          },
          {
            name: "Produced",
            type: "bar",
            data: data["hourlyData"]["PartProduced"],
            barGap: 0,
          },
          {
            name: "Rejected",
            type: "bar",
            data: data["hourlyData"]["PartRejected"],
            barGap: 0,
          },
        ],
      };
    } else if (this.selectedPameterType == "Downtime") {
      if (!data || data?.summary?.downtime?.length === 0) {
        this.hourlyOEE = {
          title: {
            text: "No Data Available",
            left: "center",
            top: "middle",
            textStyle: {
              color: "#999",
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          xAxis: { show: false },
          yAxis: { show: false },
          series: [],
        };
        return;
      }

      const categories = data["summary"]?.downtime?.map((item) => item.reason);
      const durations = data["summary"]?.downtime?.map((item) => item.duration);
      const values = data["summary"]?.downtime?.map((item) => item.value);
      // const barWidth = data["summary"]["downtime"].length <= 4 ? 80 : undefined;
      this.hourlyOEE = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            const index = params[0].dataIndex;
            const duration = durations[index];
            const cumulativeValue = values[index];
            const total = values[values.length - 1];
            const cumulativePercentage = (
              (cumulativeValue / total) *
              100
            ).toFixed(2);

            return `
      <div style="font-family: Arial; font-size: 13px; line-height: 1.6;">
        <div><b>Reason:</b> ${categories[index]}</div>
        <div><b>Duration:</b> ${moment
                .utc(duration * 60 * 1000)
                .format("HH:mm:ss")}</div>
        <div><b>Cumulative:</b> ${cumulativePercentage}%</div>
      </div>
    `;
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            color: "#333",
          },
        },
        grid: {
          top: "20%",
          left: "5%",
          right: "5%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: categories,
          name: "Reasons",
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            color: "#000",
            fontWeight: "bold",
            fontSize: 12,
          },
          axisLabel: {
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
          },
        },
        yAxis: [
          {
            type: "value",
            name: "Duration (min)",
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
            nameTextStyle: {
              color: "#000",
              fontWeight: "bold",
              fontSize: 12,
            },
            axisLabel: {
              color: "#000",
              fontSize: 10,
              fontWeight: "bold",
            },
          },
          {
            type: "value",
            name: "Cumulative %",
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 50,
            nameTextStyle: {
              color: "#000",
              fontWeight: "bold",
              fontSize: 12,
            },
            axisLabel: {
              color: "#000",
              fontSize: 10,
              fontWeight: "bold",
              formatter: "{value}%",
            },
            max: 100,
          },
        ],
        series: [
          {
            name: "Duration",
            type: "bar",
            data: durations,
            // ...(barWidth !== undefined && { barWidth }),
          },
          {
            name: "Cumulative %",
            type: "line",
            yAxisIndex: 1,
            data: values?.map((v) =>
              ((v / values[values.length - 1]) * 100).toFixed(2)
            ),
            lineStyle: {
              color: "#FF9800",
            },
            itemStyle: {
              color: "#FF9800",
            },
          },
        ],
      };
    }
  }
  formatMinutesToHHMMSS(minutes: number): string {
    if (isNaN(minutes) || minutes < 0 || !isFinite(minutes)) {
      return "00:00:00";
    }
    const totalSeconds = Math.floor(minutes * 60);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }
  getProductionChart(data: any) {
    if (
      !data ||
      data?.summary?.IdleTime ||
      data?.summary?.OffTime ||
      data?.summary?.RunningTime ||
      data?.summary?.BreakdownTime ||
      data?.summary?.InterlockTime
    ) {
      this.productionOperation = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const status = {
      idle: data["IdleTime"],
      breakdown: data["BreakdownTime"],
      interlock: data["InterlockTime"],
      off: data["OffTime"],
      running: data["RunningTime"],
    };
    const statusColors = {
      running: "#548237",
      idle: "#f7c030",
      breakdown: "#eb5857",
      interlock: "#7B542F",
      off: "#b0b0b0",
    };
    let chartData = [
      { value: status?.running ?? 0, name: "running" },
      { value: status?.idle ?? 0, name: "idle" },
      { value: status?.breakdown ?? 0, name: "breakdown" },
      { value: status.interlock ?? 0, name: "interlock" },
      { value: status?.off ?? 0, name: "off" },
    ].filter((item) => item.value > 0);
    const isNoData = chartData.length === 0;
    if (isNoData) {
      chartData = [{ value: 1, name: "No Data" }];
    }
    const chartColors = isNoData
      ? ["#e0e0e0"]
      : chartData.map((item) => statusColors[item.name] ?? "#ccc");
    this.productionOperation = {
      title: {
        text: "Operating Time",
        left: "top",
        textStyle: {
          fontSize: 12,
          color: "#000",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          if (isNoData) return "No data available";

          const durationInSeconds = Math.round(params.value * 60); // minutes → seconds
          const hours = Math.floor(durationInSeconds / 3600);
          const minutes = Math.floor((durationInSeconds % 3600) / 60);
          const seconds = durationInSeconds % 60;

          const formatted = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

          return `${params.name}:(${params.percent}%)`;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
        },
      },

      color: chartColors,
      legend: {
        show: !isNoData, // Hide legend if no data
        orient: "horizontal",
        bottom: -5,
        left: "center",
        textStyle: {
          fontSize: 10,
        },
        itemWidth: 10,
        itemHeight: 10,
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["50%", "80%"],
          avoidLabelOverlap: false,
          padAngle: 50,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: true,
            position: "center",
            formatter: isNoData ? "No Data" : "",
            fontSize: 12,
            color: "#999",
          },
          labelLine: {
            show: false,
          },
          data: chartData,
        },
      ],
    };
  }
  selectPameterType() {
    this.getHourlyOee(this.tableData);
  }
  selectType(param: string) {
    this.selectedType = param;
    if (this.tableData["downtimedata"].length) {
      this.updateChart(this.tableData["downtimedata"]);
    }
  }
  openModal(templatepdf: any, data: any, act: any) {
    this.action = act;
    this.modalService.open(templatepdf, { centered: true });
  }
  get email() {
    return this.mailform.get("email");
  }
  mailexport() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = true;
  }
  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }
  isEmailInvalid() {
    return this.email.invalid && (this.email.dirty || this.email.touched);
  }
  ngOnDestroy() { }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  ondowntimePageChange(pageNum: number): void {
    this.downtimepageSize = this.downtimeitemsPerPage * (pageNum - 1);
  }
  onrejectionPageChange(pageNum: number): void {
    this.rejectionpageSize = this.rejectionitemsPerPage * (pageNum - 1);
  }
  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }
  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }
  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
    this.exportViaMail = false;
  }
  download() {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;
    if (
      this.pdfBool &&
      this.base64String !== undefined &&
      !this.exportViaMail
    ) {
      const reportDate = moment(this.fromDate).format("YYYY-MM-DD");
      const pdfName = `Day Report ${reportDate}`;
      const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const year = moment(new Date()).format("YYYY");

      // === Header Rows ===
      const summaryHeaderRow = [
        { text: "Available Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Running Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Idle Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },

        ...(this.hasBreakdown ? [{ text: "Breakdown Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" }] : []),
        ...(this.hasInterlock ? [{ text: "Interlock Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" }] : []),

        { text: "Off Time (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Downtime (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Qty Planned", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Qty Rejected", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Availability (%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Performance (%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Quality (%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "OEE (%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Total Energy (KWh)", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      console.log(summaryHeaderRow.length)

    
       const machineHeaderRow = [
          { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Available Time", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Running Time", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Idle Time", fillColor: "#007d79", bold: true, color: "#fff" },
          ...(this.hasmchBreakdown ? [{ text: "Breakdown Time", fillColor: "#007d79", bold: true, color: "#fff" }] : []),
          ...(this.hasmchInterlock ? [{ text: "Interlock Time", fillColor: "#007d79", bold: true, color: "#fff" }] : []),
          { text: "Off Time", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Downtime", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Qty Planned", fillColor: "#007d79", bold: true, color: "#fff" },
          ...(this.hasmchpin2 ? [{ text: "Part Count 1", fillColor: "#007d79", bold: true, color: "#fff" },{ text: "Part Count 2", fillColor: "#007d79", bold: true, color: "#fff" }] : [{ text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff" }]),
          { text: "Qty Rejected", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Availability (%)", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Performance (%)", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Quality (%)", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "OEE (%)", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Energy (KWh)", fillColor: "#007d79", bold: true, color: "#fff" },
        ];
    
      console.log(machineHeaderRow.length)

      const machinedowntimeHeaderRow = [
        { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Status", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Time", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Duration(hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Reason", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "SubReason", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      const machinerejectionHeaderRow = [
        { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Shift Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Reason", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Count", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      // === Body Rows ===
      const summaryRow: string[] = [
        this.tableData?.summary?.AvailableTime ?? "00:00:00",
        this.formatMinutesToHHMMSS(this.tableData?.summary?.RunningTime ?? 0),
        this.formatMinutesToHHMMSS(this.tableData?.summary?.IdleTime ?? 0),
        ...(this.hasBreakdown ? [this.formatMinutesToHHMMSS(this.tableData.summary.BreakdownTime)] : []),
        ...(this.hasInterlock ? [this.formatMinutesToHHMMSS(this.tableData.summary.InterlockTime)] : []),
        this.formatMinutesToHHMMSS(this.tableData?.summary?.OffTime ?? 0),
        this.tableData?.summary?.Downtime ?? "00:00:00",
        (this.tableData?.summary?.Partplanned ?? 0).toString(),
        (this.tableData?.summary?.PartProduced ?? 0).toString(),
        (this.tableData?.summary?.PartRejected ?? 0).toString(),
        (this.tableData?.summary?.Availability ?? 0).toFixed(2),
        (this.tableData?.summary?.Performance ?? 0).toFixed(2),
        (this.tableData?.summary?.Quality ?? 0).toFixed(2),
        (this.tableData?.summary?.Oee ?? 0).toFixed(2),
        (this.tableData?.summary?.EnergyConsumed ?? 0).toString(),
      ];
      console.log(summaryRow)

      const machineRows =
        this.tableData?.machines?.map((m) => [
          m.Machine || "NA",
          m.ShiftName || "NA",
          this.formatMinutesToHHMMSS(m.AvailableTime ?? 0),
          this.formatMinutesToHHMMSS(m.RunningTime ?? 0),
          this.formatMinutesToHHMMSS(m.IdleTime ?? 0),
          ...(this.hasmchBreakdown
            ? [
              m.hasOwnProperty('BreakdownTime')
                ? this.formatMinutesToHHMMSS(m.BreakdownTime ?? 0)
                : 'NA'
            ]
            : []),
          ...(this.hasmchInterlock
            ? [
              m.hasOwnProperty('InterlockTime')
                ? this.formatMinutesToHHMMSS(m.InterlockTime ?? 0)
                : 'NA'
            ]
            : []),

          this.formatMinutesToHHMMSS(m.OffTime ?? 0),
          this.formatMinutesToHHMMSS(m.Downtime ?? 0),
          (m.Partplanned ?? 0).toString(),
          ...(this.hasmchpin2 ? [(m.Pin1Count ?? 0).toString(),(m.Pin2Count ?? 0).toString()] : [(m.Pin1Count ?? 0).toString()]),
          (m.PartRejected ?? 0).toString(),
          (m.Availability ?? 0).toFixed(2),
          (m.Performance ?? 0).toFixed(2),
          (m.Quality ?? 0).toFixed(2),
          (m.Oee ?? 0).toFixed(2),
          (m.EnergyConsumed ?? 0).toString(),
        ]) || [];
      console.log(machineRows)

      const machinedowntimeRows =
        this.filteredData?.map((d) => [
          d.machineName || "NA",
          d.shiftName || "NA",
          d.status || "NA",
          d.reason !== "Not Specified"
            ? `${d.fromTime || ""} - ${d.toTime || ""}`
            : "Unavailable",
          d.duration || "NA",
          d.reason || "NA",
          d.subreason || "NA",
        ]) || [];

      const machinerejectionRows =
        this.rejectionfilteredData?.map((d) => [
          d.machineName || "NA",
          d.shiftName || "NA",
          d.reason || "NA",
          d.count || "0",
        ]) || [];

      // === Build PDF content ===
      const pdfContent: any[] = [
        {
          columns: [
            {
              image: this.base64String,
              width: 140,
              height: 45,
              alignment: "left",
              margin: [-30, -28, 0, 0],
            },
          ],
        },
        {
          columns: [{ text: "DAY REPORT", fontSize: 15, bold: true, alignment: "center", margin: [0, -35, 0, 0] }],
        },
        {
          columns: [
            {
              text: `(Date :  ${reportDate})`,
              margin: [0, -10, 0, 0],
              fontSize: 10,
              bold: true,
              alignment: "center",
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              lineColor: "#007d79",
              x1: -40,
              y1: 0,
              x2: 2000,
              y2: 0,
              lineWidth: 0.05,
            },], margin: [0, 0, 0, 10],
        },
        { text: `Customer Name: ${this.custName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },
        { text: `Shift: ${this.selectedShift}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },
        { text: `Department: ${this.selectedDepartment}`, fontSize: 12, bold: true, margin: [0, 0, 0, 10] },
      ];

      // === Conditional Sections ===
      if (this.tableData?.summary) {
        pdfContent.push(
          { text: "Summary", fontSize: 12, bold: true, margin: [0, 0, 0, 8] },
          {
            table: { headerRows: 1, widths: Array(summaryHeaderRow.length).fill("*"), body: [summaryHeaderRow, summaryRow] },
            layout: { fillColor: (rowIndex) => (rowIndex === 1 ? "#d9fbfb" : null), hLineWidth: () => 0.1, vLineWidth: () => 0.1 },
            fontSize: 9,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machineRows.length > 0) {
        pdfContent.push(
          { text: "Machines", fontSize: 12, bold: true, margin: [0, 0, 0, 10] },
          {
            table: { headerRows: 1, widths: Array(machineHeaderRow.length).fill("*"), body: [machineHeaderRow, ...machineRows] },
            layout: { fillColor: (i) => (i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb"), hLineWidth: () => 0.1, vLineWidth: () => 0.1 },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machinedowntimeRows.length > 0) {
        pdfContent.push(
          { text: "Downtime Entry", fontSize: 12, bold: true, margin: [0, 0, 0, 8] },
          {
            table: { headerRows: 1, widths: Array(7).fill("*"), body: [machinedowntimeHeaderRow, ...machinedowntimeRows] },
            layout: { fillColor: (i) => (i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb"), hLineWidth: () => 0.1, vLineWidth: () => 0.1 },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      if (machinerejectionRows.length > 0) {
        pdfContent.push(
          { text: "Rejection Entry", fontSize: 12, bold: true, margin: [0, 0, 0, 8] },
          {
            table: { headerRows: 1, widths: Array(4).fill("*"), body: [machinerejectionHeaderRow, ...machinerejectionRows] },
            layout: { fillColor: (i) => (i === 0 ? null : i % 2 === 0 ? "#9ef0f0" : "#d9fbfb"), hLineWidth: () => 0.1, vLineWidth: () => 0.1 },
            fontSize: 8,
            margin: [0, 0, 0, 10],
          }
        );
      }

      // === PDF Object ===
      const pdfObject = {
        pageSize: "A3",
        pageOrientation: "landscape",
        header: () => [{ text: today, alignment: "right", margin: [0, 5, 20, 0], fontSize: 10 }],
        footer: (currentPage, pageCount) => [
          { text: `Page ${currentPage} of ${pageCount}`, alignment: "center", fontSize: 7 },
          { text: `© ${year} Wimera Systems Pvt Ltd`, alignment: "right", fontSize: 7, margin: [5, 2, 10, 20] },
        ],
        content: pdfContent,
      };

      pdfMake.createPdf(pdfObject).download(`${pdfName}.pdf`);

    } else if (this.csvBool && !this.exportViaMail) {
      const masterData = this.tableData;
      const startDate = moment(this.fromDate).format("YYYY-MM-DD");
      // Start composing CSV content
      let csvContent = "";

      // Report Info
      csvContent += "DAY REPORT\n\n";
      csvContent += `Date: ${startDate}\n\n`;
      csvContent += `Shift: ${this.selectedShift}\n\n`;
      csvContent += `Department: ${this.selectedDepartment}\n\n`;

      // === Summary Table ===
      if (masterData?.summary) {
        csvContent += "SUMMARY\n";
        csvContent +=
          [
            "Available Time (hrs)",
            "Running Time (hrs)",
            "Idle Time (hrs)",
            ...(this.hasBreakdown ? ["Breakdown Time (hrs)"] : []),
            ...(this.hasInterlock ? ["Interlock Time (hrs)"] : []),
            // "Breakdown Time (hrs)",
            // "Interlock Time (hrs)",
            "Off Time (hrs)",
            "Downtime (hrs)",
            "Qty Planned",
            "Qty Produced",
            "Qty Rejected",
            "Availability (%)",
            "Performance (%)",
            "Quality (%)",
            "Oee (%)",
            "Total Energy (KWh)",
          ].join(",") + "\n";

        csvContent +=
          [
            masterData.summary?.AvailableTime ?? "00:00:00",
            this.formatMinutesToHHMMSS(masterData.summary?.RunningTime ?? "00:00:00"),
            this.formatMinutesToHHMMSS(masterData.summary?.IdleTime ?? "00:00:00"),
            ...(this.hasBreakdown ? [this.formatMinutesToHHMMSS(this.tableData.summary?.BreakdownTime ?? "00:00:00")] : []),
            ...(this.hasInterlock ? [this.formatMinutesToHHMMSS(this.tableData.summary?.InterlockTime ?? "00:00:00")] : []),
            this.formatMinutesToHHMMSS(masterData.summary?.OffTime ?? "00:00:00"),
            masterData.summary?.Downtime ?? "00:00:00",
            Number(masterData.summary?.Partplanned ?? 0),
            Number(masterData.summary?.PartProduced ?? 0),
            Number(masterData.summary?.PartRejected ?? 0),
            Number(masterData.summary?.Availability ?? 0).toFixed(2),
            Number(masterData.summary?.Performance ?? 0).toFixed(2),
            Number(masterData.summary?.Quality ?? 0).toFixed(2),
            Number(masterData.summary?.Oee ?? 0).toFixed(2),
            Number(masterData.summary?.EnergyConsumed ?? 0),
          ].join(",") + "\n\n";
      }

      // === Machine Table ===
      if (Array.isArray(masterData?.machines) && masterData.machines.length > 0) {
        csvContent += "MACHINE DATA\n";
        csvContent +=
            [
              "Machine Name",
              "Shift Name",
              "Available Time (hrs)",
              "Running Time(hrs)",
              "Idle Time(hrs)",
              ...(this.hasmchBreakdown ? ["Breakdown Time (hrs)"] : []),
              ...(this.hasmchInterlock ? ["Interlock Time (hrs)"] : []),
              // "Breakdown Time(hrs)",
              // "Interlock Time(hrs)",
              "Off Time(hrs)",
              "Downtime (hrs)",
              "Qty Planned",
              // "Qty Produced",
              ...(this.hasmchpin2 ? ["Part Count 1","Part Count 2"] : ["Qty Produced"]),
              "Qty Rejected",
              "Availability (%)",
              "Performance (%)",
              "Quality (%)",
              "Oee (%)",
              "Total Energy (KWh)",
        ].join(",") + "\n";

        masterData.machines.forEach((machine) => {
          csvContent +=
            [
              machine?.Machine ?? "",
              machine?.ShiftName ?? "",
              this.formatMinutesToHHMMSS(machine?.AvailableTime ?? 0),
              this.formatMinutesToHHMMSS(machine?.RunningTime ?? 0),
              this.formatMinutesToHHMMSS(machine?.IdleTime ?? 0),
              ...(this.hasmchBreakdown
                ? [
                  machine.hasOwnProperty('BreakdownTime')
                    ? this.formatMinutesToHHMMSS(machine.BreakdownTime ?? 0)
                    : 'NA'
                ]
                : []),

              ...(this.hasmchInterlock
                ? [
                  machine.hasOwnProperty('InterlockTime')
                    ? this.formatMinutesToHHMMSS(machine.InterlockTime ?? 0)
                    : 'NA'
                ]
                : []),

              this.formatMinutesToHHMMSS(machine?.OffTime ?? 0),
              this.formatMinutesToHHMMSS(machine?.Downtime ?? 0),
              Number(machine?.Partplanned ?? 0),
              // Number(machine?.PartProduced ?? 0),
              ...(this.hasmchpin2 ? [(machine?.Pin1Count ?? 0),(machine?.Pin2Count ?? 0)] : [(machine?.Pin1Count ?? 0)]),
              Number(machine?.PartRejected ?? 0),
              Number(machine?.Availability ?? 0).toFixed(2),
              Number(machine?.Performance ?? 0).toFixed(2),
              Number(machine?.Quality ?? 0).toFixed(2),
              Number(machine?.Oee ?? 0).toFixed(2),
              Number(machine?.EnergyConsumed ?? 0),
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

      // === Downtime Table ===
      if (Array.isArray(this.filteredData) && this.filteredData.length > 0) {
        csvContent += "\nDOWNTIME DATA\n";
        csvContent +=
          [
            "Machine Name",
            "Shift Name",
            "Status",
            "Time",
            "Duration(hrs)",
            "Reason",
            "SubReason",
          ].join(",") + "\n";

        this.filteredData.forEach((machine) => {
          csvContent +=
            [
              machine.machineName || "",
              machine.shiftName || "",
              machine.status || "",
              machine.reason !== "Not Specified"
                ? `${machine.fromTime || ""} - ${machine.toTime || ""}`
                : "Unavailable",
              machine.duration || "",
              machine.reason || "",
              machine.subreason || "",
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

      // === Rejection Table ===
      if (Array.isArray(this.rejectionfilteredData) && this.rejectionfilteredData.length > 0) {
        csvContent += "\nREJECTION DATA\n";
        csvContent +=
          [
            "Machine Name",
            "Shift Name",
            "Reason",
            "Count",
          ].join(",") + "\n";

        this.rejectionfilteredData.forEach((machine) => {
          csvContent +=
            [
              machine.machineName || "",
              machine.shiftName || "",
              machine.reason || "",
              machine.count || "0",
            ].join(",") + "\n";
        });

        csvContent += "\n";
      }

      // === Trigger Download ===
      const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `Day_Report_${startDate}.csv`);
      document.body.appendChild(link);
      link.click();

    } else if (this.pdfBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["departmentData"] = this.tableData["summary"]),
        (maildata["machineData"] = this.tableData["machines"]),
        (maildata["downtimeData"] = this.filteredData),
        (maildata["rejectionData"] = this.rejectionfilteredData),
        (maildata["reportname"] = "dailyProductionReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["filetype"] = "pdf");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    } else if (this.csvBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["departmentData"] = this.tableData["summary"]),
        (maildata["machineData"] = this.tableData["machines"]),
        (maildata["downtimeData"] = this.filteredData),
        (maildata["rejectionData"] = this.rejectionfilteredData),
        (maildata["reportname"] = "dailyProductionReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["filetype"] = "csv");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }
}
